import Image from 'next/image'
import WxQrCode from '@/public/lingti-wx-qrcode.jpg'
import VipForm from '@/public/vip-form.png'
import Link from 'next/link'

type VipInfoProps = {
  className?: string
}

const VipInfo = ({ className = '' }: VipInfoProps) => {
  return (
    <div className={`mb-4 w-full rounded-xl border border-solid border-gray-300 p-4 text-xs lg:text-base ${className}`}>
      <div className="font-bold">解锁更多比赛类型/设置,您可以:</div>
      <div className="mt-3 font-bold">1. 以点数购买单次比赛权限</div>
      <div className="mt-2">
        <div className="flex flex-row items-center">
          <div className="mr-2 h-2 w-2 rounded-full bg-black" />
          前往
          <Link href="/billing">点数充值页</Link>
        </div>
      </div>
      <div className="mt-3 font-bold">2. 选择升级VIP</div>
      <div className="mt-3">
        <div className="flex flex-row items-center">
          <div className="mr-2 h-2 w-2 rounded-full bg-black" />
          前往
          <Link href="/vip_billing">购买页</Link>
        </div>
      </div>
      <div className="mt-3">
        <div className="flex flex-row items-center">
          <div className="mr-2 h-2 w-2 rounded-full bg-black" />
          联系臧经理
          <a href="tel:15370036553">15370036553</a>
        </div>
      </div>
      <div className="mt-3 grid max-w-[400px] grid-cols-2 gap-2 lg:gap-4">
        <div>
          <div className="flex flex-row items-center">
            <div className="mr-2 h-2 w-2 rounded-full bg-black" />
            扫码填写<span className="font-bold">申请表</span>
          </div>
          <div className="relative mt-2 aspect-square">
            <Image className="mx-auto border border-solid border-gray-200" src={VipForm} alt="" fill />
          </div>
        </div>
        <div>
          <div className="flex flex-row items-center">
            <div className="mr-2 h-2 w-2 rounded-full bg-black" />
            <span className="whitespace-nowrap">
              公众号<span className="whitespace-nowrap font-bold">灵缇互娱</span>
            </span>
          </div>
          <div className="relative mt-2 aspect-square">
            <Image className="m-auto border border-solid border-gray-200" src={WxQrCode} alt="" fill />
          </div>
        </div>
      </div>
    </div>
  )
}
export default VipInfo
